import { render, staticRenderFns } from "./UpdateFile.vue?vue&type=template&id=5fa41355&scoped=true&"
import script from "./UpdateFile.vue?vue&type=script&lang=js&"
export * from "./UpdateFile.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFile.vue?vue&type=style&index=0&id=5fa41355&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa41355",
  null
  
)

export default component.exports